<template>
  <div>
    <!-- 标题及按钮 -->
    <mtd-row>
      <mtd-col :span="12" class="height-full">
        <div class="page-title-32">文件流转详情</div>
      </mtd-col>
    </mtd-row>
    <!-- 数据来源检索 -->
    <mtd-row class="search-block" style="margin-top: 12px;" :gutter="16">
      <mtd-form :model="query_params" :label-width="74">
        <mtd-col :span="8" style="padding-left: 0;">
          <mtd-form-item label="MISID:">
            <mtd-select v-model="query_params.otherMisId" placeholder="请输入用户MISID" :filterable="true" clearable
                        style="width: 100%" :remote="true" :remote-method="searchPerson" :debounce="500"
                        key="search_misid">
              <mtd-option v-for="item in person_groups" :key="item.name + '/' + item.mis"
                          :label="item.name + '/' + item.mis" :value="item.mis"/>
            </mtd-select>
          </mtd-form-item>
        </mtd-col>
        <mtd-col :span="8">
          <mtd-form-item prop="params" label="文档名称:">
            <mtd-input placeholder="请输入需要查询的文档名称" style="width: 100%;" v-model="query_params.fileName"
                       clearable/>
          </mtd-form-item>
        </mtd-col>
        <mtd-col :span="8" style="padding-right: 0">
          <mtd-form-item prop="dataSource" label="数据来源:">
            <mtd-select v-model="query_params.dataSource" style="width: 100%" @change="build_start_and_query_dt">
              <mtd-option label="学城" value="km"/>
              <mtd-option label="大象" value="xm"/>
            </mtd-select>
          </mtd-form-item>
        </mtd-col>
        <mtd-col :span="8" style="padding-left: 0">
          <mtd-form-item prop="appealStatus" label="操作类型:" style="margin-bottom: 0;">
            <mtd-select style="width: 100%;" v-model="query_params.operateType" clearable>
              <mtd-option label="查看" value="查看"/>
              <mtd-option label="转发" value="转发"/>
              <mtd-option label="下载" value="下载"/>
              <mtd-option label="外发" value="外发"/>
            </mtd-select>
          </mtd-form-item>
        </mtd-col>
        <mtd-col :span="8">
          <mtd-form-item label="时间分区:" style="margin-bottom: 0;">
            <mtd-date-picker type="date" v-model="query_params.startDt" placeholder="请选择时间分区" disabled
                             value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width: calc(50% - 12px)"
                             class="disabled-picker-block"/>
            <mtd-icon name='minus' style="width: 24px;text-align: center;"></mtd-icon>
            <mtd-date-picker type="date" v-model="query_params.endDt" placeholder="请选择时间分区"
                             value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width: calc(50% - 12px)"
                             @change="build_start_and_query_dt"/>
          </mtd-form-item>
        </mtd-col>
        <mtd-col :span="8" style="padding-right: 0; text-align: right;">
          <mtd-button type="text-primary" style="width: 70px;" @click="reset_search_form">重置</mtd-button>
          <mtd-button ghost type="primary" style="width: 80px;" @click="list_file_detail">查询</mtd-button>
        </mtd-col>
      </mtd-form>
    </mtd-row>
    <!-- 文件流转详情表格 -->
    <mtd-table :data="alarm_detail_list" size="small" style="margin-top:12px;">
      <mtd-table-column prop="filename" label="文档名称" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.dataSource === 'xm'">{{ scope.row.filename }}</span>
          <span v-if="scope.row.dataSource === 'km'">
              <a :href="'https://km.sankuai.com/page/'+scope.row.filemd5" target="_blank">{{ scope.row.filename }}</a>
            </span>
        </template>
      </mtd-table-column>
      <mtd-table-column prop="misid" label="文档归属人" width="120" show-overflow-tooltip/>
      <mtd-table-column prop="misidObj" label="操作人" width="120" show-overflow-tooltip/>
      <mtd-table-column prop="nameObj" label="姓名" width="100" show-overflow-tooltip/>
      <mtd-table-column prop="orgPathNameObj" label="操作人组织架构" width="260" show-overflow-tooltip/>
      <mtd-table-column prop="operateStartTimeObj" label="操作时间" width="140"/>
      <mtd-table-column prop="tag" label="操作行为" width="100">
        <template slot-scope="scope">
          <mtd-popover v-if="scope.row.tag === '转发'" trigger="click" placement="top">
            <div slot="content">
              <span>{{ scope.row.actionExtObj }}</span>
            </div>
            <span style="cursor: pointer;">{{ scope.row.tag }}</span>
          </mtd-popover>
          <span v-else>{{ scope.row.tag }}</span>
        </template>
      </mtd-table-column>
      <mtd-table-column prop="sourceObj" label="数据源" width="80"/>
      <mtd-table-column prop="viewUserCnt" label="数据来源" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.dataSource === 'xm'">大象</span>
          <span v-if="scope.row.dataSource === 'km'">学城</span>
        </template>
      </mtd-table-column>
    </mtd-table>
    <div style="text-align: right;margin-top: 12px;">
      <mtd-pagination size="small" show-size-changer show-total :total="query_params.tn"
                      :page-size="query_params.sn"
                      :current-page.sync="query_params.cn" @change="change_page"/>
    </div>
  </div>
</template>

<script>

  import {mapActions} from 'vuex'
  import moment from "moment";

  export default {
    name: "alert_detail",
    data() {
      return {
        alarm_detail_list: [],
        submitLoading: false,
        query_params: {
          otherMisId: null,
          fileName: '',
          fileNameLike: '',
          operate_time: [],
          operateType: '',
          dataSource: 'km',
          startDt: null,
          endDt: null,
          queryDt: null,
          cn: 1, // 当前页面
          sn: 10, // 每页大小
          tn: 0 // 总条数
        },
        person_groups: [],
        depart_groups: [],
      }
    },
    mounted: function () {
      // 1.首先获取传递的参数
      let {filename, dataSource, queryDt, otherMisId, endDt} = this.$route.params;
      if (filename && filename !== '') {
        this.query_params.fileName = filename;
      }
      if (dataSource && dataSource !== '') {
        this.query_params.dataSource = dataSource;
      }
      if (queryDt && (/^\d{8}$/.test(queryDt))) {
        this.query_params.queryDt = queryDt;
      }
      if (otherMisId && otherMisId !== '') {
        this.query_params.otherMisId = otherMisId;
      }
      if (endDt && (/^\d{4}-\d{2}-\d{2}$/.test(endDt))) {
        this.query_params.endDt = endDt;
      } else {
        this.query_params.endDt = this.get_default_dt();
      }
      this.build_start_and_query_dt();
      this.$emit("reload_active_tab");
      if (otherMisId && otherMisId !== '') {
        this.list_file_detail();
      }
    },
    methods: {
      // API方法
      ...mapActions({
        api_list_file_detail: 'api_file_trace_other_detail_list',
        api_file_detail_report: 'api_file_trace_file_detail_report',
        query_mis_id_list: 'query_mis_id_list',
        query_org_list: 'query_org_list'
      }),
      get_default_dt() {
        return moment().add(-1, 'days').utcOffset(480).format('YYYY-MM-DD');
      },
      build_start_and_query_dt() {
        let dt_date = moment(this.query_params.endDt);
        this.query_params.queryDt = dt_date.format('YYYYMMDD');
        let days = -1;
        if (this.query_params.dataSource === 'xm') {
          days = -6;
        }
        dt_date.add(days, 'days').utcOffset(480);
        this.query_params.startDt = dt_date.format('YYYY-MM-DD');
      },
      list_file_detail() {
        let {otherMisId} = this.query_params;
        if (!otherMisId || otherMisId === '') {
          return this.$mtd.message.warning("请输入用户MisId");
        }
        if (this.query_params.operate_time.length === 2) {
          this.query_params.operateStartTime = this.query_params.operate_time[0] + " 00:00:00";
          this.query_params.operateEndTime = this.query_params.operate_time[1] + " 23:59:59";
        } else {
          this.query_params.operateStartTime = null;
          this.query_params.operateEndTime = null;
        }
        this.query_params.size = this.query_params.sn;
        this.query_params.page = this.query_params.cn;
        this.api_list_file_detail(this.query_params).then((res) => {
          if (res.code === 0) {
            let {currentPage, limit, total, items} = res.data;
            this.alarm_detail_list = items;
            this.query_params.cn = currentPage;
            this.query_params.sn = limit;
            this.query_params.tn = total;
          } else {
            this.$mtd.message.error('获取数据失败');
          }
        });
      },

      reset_search_form() {
        this.query_params.otherMisId = null;
        this.query_params.fileName = '';
        this.query_params.fileNameLike = '';
        this.query_params.operate_time = [];
        this.query_params.operateType = '';
        this.query_params.dataSource = 'km';
        this.query_params.endDt = this.get_default_dt();
        this.build_start_and_query_dt();
        this.list_file_detail();
      },

      change_page(current, size) {
        this.query_params.cn = current;
        this.query_params.sn = size;
        this.list_file_detail();
      },
      // 搜索mis
      searchPerson(keyword) {
        if (keyword != null && keyword !== "") {
          this.query_mis_id_list({keyword}).then(res => {
            this.person_groups = res.data
          }).catch((err) => {
            console.log(err)
          })
        }
      },
      // 搜索BU BG
      searchDepart(keyword) {
        if (keyword != null && keyword !== "") {
          keyword = keyword.replace(/\//g, "-");
          this.query_org_list({keyword}).then(res => {
            this.depart_groups = res.data
          }).catch((err) => {
            console.log(err)
          })
        }
      },
    }
  }
</script>

<style>
  @import "../../../styles/public.css";
  @import "../../../styles/reset_table.css";

  .search-block {
    background: #F7F7F7;
    padding: 12px 16px;
  }

  .search-block .mtd-form-item {
    width: 100%;
  }

  div.disabled-picker-block .mtd-input-disabled {
    opacity: 1;
  }
</style>
